import { render, staticRenderFns } from "./SmsPhoneOptionsSelector.vue?vue&type=template&id=9ba2fd4c&scoped=true"
import script from "./SmsPhoneOptionsSelector.vue?vue&type=script&lang=js"
export * from "./SmsPhoneOptionsSelector.vue?vue&type=script&lang=js"
import style0 from "./SmsPhoneOptionsSelector.vue?vue&type=style&index=0&id=9ba2fd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2fd4c",
  null
  
)

export default component.exports